"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _netlifyCmsUiDefault = require("netlify-cms-ui-default");

var _core = require("@emotion/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TextPreview(_ref) {
  let {
    value
  } = _ref;
  return (0, _core.jsx)(_netlifyCmsUiDefault.WidgetPreviewContainer, null, value);
}

TextPreview.propTypes = {
  value: _propTypes.default.node
};
var _default = TextPreview;
exports.default = _default;